/**
 * @author Matthew Rogers.
 * Section for Dispute details...and potential actions
 */
var disBind = { vm: '=' };
var DisputeDetailsController = (function () {
    function DisputeDetailsController(topic) {
        this.topic = topic;
        this.cdIndicator = 'Credit';
    }
    DisputeDetailsController.prototype.$onInit = function () {
        var cd = this.topic.topic.dispute_details.dispute_itrtype ? this.topic.topic.dispute_details.dispute_itrtype : 'C';
        this.cdIndicator = cd === 'C' ? 'Credit' : 'Debit';
        this.disputeDetails = 'This is a Dispute.  The details are as follows:\n\n' +
            'Original Disbursement: ' + this.topic.topic.dispute_details.parent +
            '\nCredit/Debit: ' + this.cdIndicator +
            '\nType: ' + this.topic.topic.dispute_details.dispute_type +
            '\nCode: ' + this.topic.topic.dispute_details.dispute_code +
            '\n\nView the parent Disbursement via \'Your Actions\'';
    };
    DisputeDetailsController.$inject = ['topic'];
    return DisputeDetailsController;
}());
var DisputeDetailsComponent = (function () {
    function DisputeDetailsComponent() {
        this.bindings = disBind;
        this.templateUrl = 'dispute-details.html';
        this.controller = DisputeDetailsController;
    }
    return DisputeDetailsComponent;
}());
angular
    .module('application')
    .component('disputeDetailsSection', new DisputeDetailsComponent());

//# sourceMappingURL=dispute.details.component.js.map
